import { Action } from '@ngrx/store';

import { NavItemsActionType } from './nav-items-action-type.enum';

export class NavItemsReset implements Action {
  public readonly type: NavItemsActionType = NavItemsActionType.ResetNavItems;
  public readonly payload: any = undefined;
}
